import { render } from "./StoryDetail.vue?vue&type=template&id=2f0751a6&scoped=true"
import script from "./StoryDetail.vue?vue&type=script&lang=js"
export * from "./StoryDetail.vue?vue&type=script&lang=js"

import "./StoryDetail.vue?vue&type=style&index=0&id=2f0751a6&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0751a6"]])

export default __exports__